import type { ListResponse, ObjectResponse } from '../../../common/types';
import { QueueDropdownResponse } from '../../../features/workspace-common/types/responseTypes';
import { annotationToolApiV1, getAnnotationToolBasePath } from '../../../lib';
import { SUPERVISOR_QUEUE_TAG } from '../constants';
import type {
    SupervisorAllocationSummaryResponse,
    SupervisorTaskResponse,
} from '../types/responseTypes';

export const supervisorQueueApiSlice = annotationToolApiV1
  .enhanceEndpoints({
    addTagTypes: [SUPERVISOR_QUEUE_TAG],
  })
  .injectEndpoints({
    overrideExisting: true,
    endpoints: (builder) => ({
      getSupervisorAllocationSummary: builder.query<
        ObjectResponse<SupervisorAllocationSummaryResponse>,
        {
          projectId: string;
          batchId: string;
        }
      >({
        query: ({ projectId, batchId }) => {
          const basePath = getAnnotationToolBasePath();
          const tempPath = '/internal-message-gateway' + basePath;
          const params = new URLSearchParams();
          params.append('project_id', projectId);
          params.append('batch_id', batchId);
          const queryString = params.toString() ? `?${params.toString()}` : '';
          return `${tempPath}/work-queue/supervisor-allocations/summary${queryString}`;
        },
        providesTags: [SUPERVISOR_QUEUE_TAG],
      }),
      getSupervisorEncounters: builder.query<
        ListResponse<SupervisorTaskResponse>,
        {
          projectId: string;
          batchId: string;
        }
      >({
        query: ({ projectId, batchId }) => {
          const basePath = getAnnotationToolBasePath();
          const tempPath = `/internal-message-gateway${basePath}`;

          return {
            url: `${tempPath}/work-queue/supervisor-encounters`,
            method: 'GET',
            params: {
              project_id: projectId,
              batch_id: batchId,
            },
          };
        },
        providesTags: [SUPERVISOR_QUEUE_TAG],
      }),
      getSupervisorProjects: builder.query<ListResponse<QueueDropdownResponse>, void>({
        query: () => {
          const basePath = getAnnotationToolBasePath();
          const tempPath = '/internal-message-gateway' + basePath;
          return `${tempPath}/projects/supervisor-projects`;
        },
        providesTags: [SUPERVISOR_QUEUE_TAG],
      }),
      getSupervisorBatches: builder.query<
        ListResponse<QueueDropdownResponse>,
        { projectId: string }
      >({
        query: ({ projectId }) => {
          const basePath = getAnnotationToolBasePath();
          const tempPath = '/internal-message-gateway' + basePath;
          return `${tempPath}/projects/${projectId}/supervisor-batches`;
        },
        providesTags: [SUPERVISOR_QUEUE_TAG],
      }),
    }),
  });

export const {
  useGetSupervisorAllocationSummaryQuery,
  useGetSupervisorEncountersQuery,
  useGetSupervisorProjectsQuery,
  useGetSupervisorBatchesQuery,
} = supervisorQueueApiSlice;
